/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminTreasurySolvencyRow } from '../openapi-types.gen.js';
import { type useGetAdminTreasurySolvencyArgs, useGetAdminTreasurySolvencySpec } from '../specs/admin.spec.gen.js';

export type { GetAdminTreasurySolvencyRow } from '../openapi-types.gen.js';
export type { useGetAdminTreasurySolvencyArgs } from '../specs/admin.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): limit.
 */
const _useGetAdminTreasurySolvency = createHook(useGetAdminTreasurySolvencySpec);
export const useGetAdminTreasurySolvency = _useGetAdminTreasurySolvency as (args: useGetAdminTreasurySolvencyArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminTreasurySolvency>;


/**
 * Hover/intent prefetch companion for `useGetAdminTreasurySolvency`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetAdminTreasurySolvency();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminTreasurySolvency = createPrefetchHook(useGetAdminTreasurySolvencySpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminTreasurySolvencyArgs>;
